<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="6.35mm"
    height="5.64428mm"
    viewBox="0 0 18 15.99954"
  >
    <defs />
    <title>cuore2</title>
    <g id="Livello_2" data-name="Livello 2">
      <g id="Livello_1-2" data-name="Livello 1">
        <path
          id="iconmonstr-favorite-1-2"
          class="cls-1"
          d="M9,2.49954c-1.492-3.928-9-3.345-9,2.593,0,2.959,2.295,6.895,9,10.907,6.705-4.012,9-7.948,9-10.907C18-.81146,10.5-1.45246,9,2.49954Z"
        />
      </g>
    </g>
  </svg>
</template>
<script>
export default {
  name: 'LikeHeart'
};
</script>
<style lang="scss" scoped>
.cls-1 {
  stroke: #a21c20;
  fill: transparent;
  stroke-width: 0.3;
  // opacity: 0.5;
}
.user-like .cls-1 {
  stroke: none;
  fill: #a21c20;
  // opacity: 1;
}
</style>
